module.exports = __webpack_public_path__ + "assets/img/Back_005.0eef76ce-ps.jpg";